export default __webpack_public_path__ + "static/media/voice-over_tonny.130d72a0.mp3";